<template>
  <app-layout :title="``">
    <template #header>
      <div class="flex w-full justify-between items-center">
        <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none" v-html="title">
        </h2>
        <div class="flex gap-x-[5px] md:gap-x-[40px] justify-between">

        </div>
      </div>
    </template>

    <div class="mx-auto py-4">

      <pre v-if="modelList">{{ modelList.data }}</pre>

      <div class="flow-root">
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <table class="min-w-full divide-y divide-slate-300">
              <thead>
                <tr>
                  <th scope="col" class="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                    <span class="sr-only">Edit</span>
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    Name
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    Favicon
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    Domain
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    Mentions count
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-200 bg-white">
                <tr v-for="item in modelList.data" :key="item.id">
                  <td class="whitespace-nowrap py-2 px-0">
                    <EditButton :href="route(`${prefixRoute}.show`, item.id)" />
                  </td>
                  <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-slate-900 sm:pl-0">
                    <div class="max-w-[250px] truncate overflow-hidden">
                      {{ item.name }}
                    </div>
                  </td>

                  <td class="whitespace-nowrap px-2 py-2">
                    <img v-if="item.favicons" :src="item.favicons" loading="lazy"
                      class="h-[70px] w-[70px] object-cover border border-slate-200 rounded-[4px] box-content"
                      alt="Cover Image" />
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-slate-500">
                    <div class="max-w-[250px] truncate overflow-hidden">
                      {{ item.name }}
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-slate-500">
                    <div class="max-w-[250px] truncate overflow-hidden">
                      {{ item.mentions_count }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import EditButton from '@/Components/Tables/EditButton.vue';

defineProps({
  modelList: Object,
  prefixRoute: String,
  title: String
});
</script>
